module.exports = __webpack_public_path__ + "img/四川天府新区太阳花幼儿园.db8375b6.jpg";